import {
  SYSTEM_WORKEXPERIENCE_MODAL_CHANGE,
} from './constants';

export function workExperienceModalChange(visible,type) {
  return {
    type: SYSTEM_WORKEXPERIENCE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_WORKEXPERIENCE_MODAL_CHANGE:
      return {
        ...state,
        workExperienceModalType:action.data.type,
        workExperienceModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/workExperienceModalChange.js